// extracted by mini-css-extract-plugin
export default {"containerUserMenu":"userMenu__containerUserMenu___sAOgE","dropdownItems":"userMenu__dropdownItems___RNkZO"};